import Vue from 'vue'
import axios from 'axios'
import Vuelidate from 'vuelidate'
import App from './App.vue'
import router from './router'
import store from './store'

axios.interceptors.response.use(null, error => {
  if (error.response.status === 401) {
    store.commit('auth/logout')
    router.replace('/secure')
    store.dispatch('toast/addToast', {
      message: 'session expired',
      type: 'danger',
    })
  }
  return Promise.reject(error)
})

Vue.use(Vuelidate)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
